import { createContext } from 'react';

const clientContext = createContext<Record<string, Record<string, unknown>>>(
  {},
);

export { clientContext };
